import Head from 'next/head';
import generalConfig from '@/config/general';
import envConfig from '@/config/environment';
import dates from '@/utils/date';
import { jsx as _jsx } from "react/jsx-runtime";

const JsonSchemaPage = _ref => {
  let {
    url,
    type = 'WebSite',
    headline,
    createdAt,
    updatedAt,
    imgSrc = envConfig.defaultSocialImg,
    imgWidth = 600,
    imgHeight = 400,
    authors = [],
    editors = []
  } = _ref;
  const result = {
    '@context': 'http://schema.org',
    '@type': type,
    dateModified: dates.toIsoDate(updatedAt),
    datePublished: dates.toIsoDate(createdAt),
    headline,
    image: {
      '@type': 'ImageObject',
      width: imgWidth,
      height: imgHeight,
      url: imgSrc.indexOf(envConfig.baseUrl) === 0 ? imgSrc : `${envConfig.baseUrl}${imgSrc.replace(/^\//, '/')}`
    },
    mainEntityOfPage: {
      '@id': `${envConfig.baseUrl}${url}`,
      '@type': 'WebPage'
    },
    publisher: {
      '@type': 'Organization',
      logo: {
        '@type': 'ImageObject',
        url: `${envConfig.baseUrl}/img/standalone-app/icon-192x192.png`
      },
      name: generalConfig.productName
    }
  }; // Append optional authors

  if (authors.length) {
    // @ts-ignore
    result.author = authors.map(author => {
      const avatarUrl = author ? addBaseUrl(author.avatarUrl) : '';
      const authorResult = {
        '@type': 'Person',
        name: author.fullName,
        sameAs: [`${envConfig.baseUrl}/authors/${author.slug}`, ...(author.socialUrls || [])]
      };

      if (avatarUrl) {
        // @ts-ignore
        authorResult.image = avatarUrl;
      }

      return authorResult;
    });
  }

  if (editors.length) {
    // @ts-ignore
    result.editor = editors.map(author => {
      return {
        '@id': `${envConfig.baseUrl}/authors/${author.slug}`
      };
    });
  }

  return /*#__PURE__*/_jsx(Head, {
    children: /*#__PURE__*/_jsx("script", {
      type: "application/ld+json" // @ts-ignore
      ,
      dangerouslySetInnerHTML: {
        __html: JSON.stringify(result)
      }
    })
  });
};

export default JsonSchemaPage; // Prepend the current base url to a
// relative url string or past through
// unmodified

function addBaseUrl() {
  let url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

  if (url.search('/') === 0) {
    return `${envConfig.baseUrl}${url}`.replace(/\/\//g, '/');
  }

  return url;
}